import { formatMarketingReportCell } from './marketingPersonReportSections';

function MarketingPersonReportSection({
  title,
  description,
  type = 'table',
  countValue,
  columns = [],
  rows = [],
  isLoading,
}) {
  if (isLoading) {
    return (
      <section className="marketing-report-section">
        <h5 className="marketing-report-section-title">{title}</h5>
        <div className="text-center py-3 text-muted">Loading...</div>
      </section>
    );
  }

  if (type === 'count') {
    return (
      <section className="marketing-report-section">
        <h5 className="marketing-report-section-title">{title}</h5>
        {description && (
          <p className="marketing-report-section-description">{description}</p>
        )}
        <div className="marketing-report-count-card">{countValue ?? 0}</div>
      </section>
    );
  }

  return (
    <section className="marketing-report-section">
      <h5 className="marketing-report-section-title">
        {title}
        {type !== 'count' && (
          <span className="marketing-report-section-count">{rows.length}</span>
        )}
      </h5>
      {description && (
        <p className="marketing-report-section-description">{description}</p>
      )}
      {type === 'count' ? (
        <div className="marketing-report-count-card">{countValue ?? 0}</div>
      ) : rows.length === 0 ? (
        <div className="marketing-report-empty">No records found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered customer-site-stats-detail-table marketing-report-section-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.key}
                    className={column.align ? `text-${column.align}` : undefined}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={row.id || `${title}-${index}`}>
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      className={column.align ? `text-${column.align}` : undefined}
                    >
                      {formatMarketingReportCell(row[column.key], column.key)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default MarketingPersonReportSection;
